module.exports = __webpack_public_path__ + "img/bg-section-07-mobile.f1208046.svg";